import React from 'react'
import parser from 'html-react-parser'
import { Link } from 'gatsby'
import {hVidContainer, heroOverlay} from './Hero1.module.css'

export default function Hero1({ data }) {
    const { buttonText, hero1ButtonLink, hero1DesktopImage, hero1MobileImage, hero1Text, hero1Title110, hero1Video, hero1NumberOfColumns, hero1BackgroundPosition, hero1GradientOverlay, hero1ButtonExternalLink } = data
    return (
        <div
            className={`inner-banner vid-inr-wrap hero-overlay m-blue-overlay font-white  ${hero1GradientOverlay ? '' : heroOverlay}`}
            style={{
                background: `url(${hero1DesktopImage?.localFile?.publicURL}) left ${hero1BackgroundPosition} no-repeat`,
            }}
        >
            <div
                className='inner-mobile-hero-bg'
                style={{
                    background: `url(${hero1MobileImage?.localFile?.publicURL}) center top no-repeat`,
                }}
            ></div>
            <video className='home-hero-video' muted loop autoPlay='play'>
                <source src={hero1Video?.localFile?.publicURL} type='video/webm' />
            </video>
            <div className={`container h-vid-container ${hVidContainer}`}>
                <div className='row'>
                    <div className={`col-md-${hero1NumberOfColumns}`}>
                        <h1 className='heading-level-1'>{hero1Title110 && parser(hero1Title110)}</h1>
                        <p>{hero1Text && parser(hero1Text)}</p>
                        {hero1ButtonExternalLink ? (
                            <a href={hero1ButtonExternalLink} className="btn white-btn">
                                {buttonText}
                            </a>
                        ) : hero1ButtonLink ? <Link to={`${hero1ButtonLink.uri}`} className='btn white-btn'>
                            {buttonText}
                        </Link> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
